import { Search } from 'lucide-react'
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from '@/components/ui/sidebar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useGlobalCommandPalette } from '@/components/GlobalCommandPalette'
import { CommandPaletteContent } from '@/components/GlobalCommandPalette/CommandPaletteContent'

export default function SidebarSearch() {
  const { isOpen, setIsOpen } = useGlobalCommandPalette()

  return (
    <SidebarGroup className="py-0">
      <SidebarMenu>
        <SidebarMenuItem>
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
              <SidebarMenuButton tooltip="Buscar (⌘K)">
                <Search className="h-4 w-4" />
                <span className="group-data-[collapsible=icon]:hidden">Buscar</span>
                <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100 group-data-[collapsible=icon]:hidden">
                  ⌘K
                </kbd>
              </SidebarMenuButton>
            </PopoverTrigger>
            <PopoverContent
              side="right"
              align="start"
              sideOffset={8}
              className="w-[420px] p-0"
              onOpenAutoFocus={(e) => e.preventDefault()}
            >
              <CommandPaletteContent onClose={setIsOpen} />
            </PopoverContent>
          </Popover>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}
